import { goToLogin } from '../../router';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5041';

const servicioService = (() => {
  const axios = require('axios');

  const instance = axios.create({
    baseURL: API_URL,
    withCredentials: true, // Include cookies in requests
  });

  // Interceptor de respuesta para redirigir al login si token expiró
  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        goToLogin();
      }
      return Promise.reject(error);
    }
  );

  instance.interceptors.request.use(
    config => {
      const token = localStorage.getItem('jwt-token');
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  
  const addServicio = async (Servicio) => {
    try {
      const response = await instance.post('/Servicio', Servicio);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };
   

  const getAllServicios = async () => {
    try {
      const response = await instance.get('/Servicio');
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const getById = async (id) => {
    try {
      const response = await instance.get(`/Servicio/${id}`);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  
  
  const editServicio = async (id, Servicio) => {
    // debugger
    // console.log("EditServicio",servicio)
    try {
      const response = await instance.put(`/Servicio/${id}`, Servicio);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };
  

  const deleteServicio = async (id) => {
    try {
      const response = await instance.delete(`/Servicio/${id}`);
      if (response.status === 204) { // No Content, indicando éxito
        return response.data;
      } else {
        throw new Error("Respuesta inesperada del servidor."); // Maneja cualquier otro código de estado no esperado
      }
    } catch (error) {
      if (error.response) {
        console.log("Error al eliminar el servicio:", error.response.data);
        // Devuelve el mensaje de error para manejo en la UI
        throw error.response.data; // Lanzar el error para ser capturado por el llamador
      } else {
        console.log("Error no relacionado con la respuesta:", error);
        throw new Error("Error al eliminar el servicio."); // Lanzar error genérico
      }
    }
  };

//   const updatePlazas = async (servicioId, plazasVendidas) => {
//     try {
//         const payload = { plazasVendidas: plazasVendidas };
//         const response = await instance.put(`/Servicio/${servicioId}`, payload);
//         return response.data;
//     } catch (error) {
//         console.error('Error al actualizar plazas:', error);
//         throw error; // Lanza el error para que el componente lo maneje
//     }
// };
  


  return {
    addServicio,
    getById,
    editServicio,
    deleteServicio,
    getAllServicios,
    //updatePlazas
  };
})();

export default servicioService;
